import { orange } from '@/theme/colors'
import styled from 'styled-components'

export const FormGroup = styled.div`
    margin-bottom: 1.25rem;

    &:last-child {
        margin-bottom: 0;
    }
`

export const FormLabel = styled.label`
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    margin-bottom: 8px;
`

export const FormInput = styled.input`
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 16px;
    transition: border-color 0.2s, box-shadow 0.2s;

    &:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }

    &::placeholder {
        color: #9ca3af;
    }
`

export const FormSelect = styled.select`
    width: 100%;
    padding: 12px 48px 12px 16px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 16px;
    background-color: white;
    cursor: pointer;
    transition: border-color 0.2s, box-shadow 0.2s;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23374151' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 16px center;

    &:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
`

export const AmountInputWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`

export const AmountPrefix = styled.span`
    position: absolute;
    left: 16px;
    font-size: 16px;
    color: #6b7280;
    pointer-events: none;
`

export const AmountInput = styled.input`
    width: 100%;
    padding: 12px 16px 12px 32px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 16px;
    transition: border-color 0.2s, box-shadow 0.2s;

    &:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }

    &::placeholder {
        color: #9ca3af;
    }

    /* Hide spinner arrows */
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    -moz-appearance: textfield;
`

export const SplitTypeContainer = styled.div`
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1rem;
`

export const SplitTypeButton = styled.button<{ $active: boolean }>`
    flex: 1;
    padding: 0.5rem 0.75rem;
    border-radius: 8px;
    font-size: 0.8125rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid ${({ $active }) => ($active ? orange : '#d1d5db')};
    background: ${({ $active }) => ($active ? orange : 'white')};
    color: ${({ $active }) => ($active ? 'white' : '#374151')};

    &:hover {
        border-color: ${orange};
    }
`

export const ParticipantsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
`

export const ParticipantRow = styled.div<{ $isSelected: boolean }>`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.5rem 0.75rem;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.15s;
    background: ${({ $isSelected }) => ($isSelected ? '#fef3e2' : 'transparent')};

    &:hover {
        background: ${({ $isSelected }) => ($isSelected ? '#fef3e2' : '#f9fafb')};
    }
`

export const ParticipantCheckbox = styled.div<{ $checked: boolean }>`
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 2px solid ${({ $checked }) => ($checked ? orange : '#d1d5db')};
    background: ${({ $checked }) => ($checked ? orange : 'white')};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.15s;

    &::after {
        content: '${({ $checked }) => ($checked ? '\\2713' : '')}';
        color: white;
        font-size: 12px;
        font-weight: 700;
    }
`

export const ParticipantName = styled.span`
    font-size: 0.875rem;
    font-weight: 500;
    color: #262626;
    flex: 1;
`

export const ParticipantSplitInput = styled.input`
    width: 80px;
    padding: 0.375rem 0.5rem;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 0.8125rem;
    text-align: right;

    &:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
    }

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    -moz-appearance: textfield;
`

export const SplitSummary = styled.div`
    font-size: 0.75rem;
    color: #6b7280;
    margin-top: 0.5rem;
    padding: 0.5rem 0.75rem;
    background: #f9fafb;
    border-radius: 6px;
`

export const SplitError = styled.span`
    color: #dc2626;
    font-weight: 500;
`

export const ButtonGroup = styled.div`
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 1rem;
`

export const Button = styled.button<{ variant?: 'primary' | 'secondary' | 'danger' }>`
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    border: none;

    ${({ variant = 'secondary' }) => {
        switch (variant) {
            case 'primary':
                return `
                    background-color: ${orange};
                    color: white;

                    &:hover:not(:disabled) {
                        opacity: 0.9;
                    }

                    &:disabled {
                        opacity: 0.5;
                        cursor: not-allowed;
                    }
                `
            case 'danger':
                return `
                    background-color: #dc2626;
                    color: white;

                    &:hover:not(:disabled) {
                        background-color: #b91c1c;
                    }
                `
            default:
                return `
                    background-color: white;
                    color: #374151;
                    border: 1px solid #d1d5db;

                    &:hover {
                        background-color: #f3f4f6;
                    }
                `
        }
    }}
`

export const FormDescription = styled.p`
    font-size: 0.75rem;
    color: #9ca3af;
    margin: -4px 0 8px;
`

export const HiddenInput = styled.input`
    display: none;
`

export const ImageSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`

export const ImagePreview = styled.div`
    width: 3.75rem;
    height: 3.75rem;
    border-radius: 0.5rem;
    overflow: hidden;
    cursor: pointer;
    flex-shrink: 0;
    position: relative;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`

export const ImagePlaceholder = styled.label`
    width: 3.75rem;
    height: 3.75rem;
    border-radius: 0.5rem;
    border: 2px dashed #d1d5db;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    transition: border-color 0.2s, background 0.2s;
    background: #f9fafb;

    &:hover {
        border-color: ${orange};
        background: #fef3e2;
    }

    svg {
        width: 1.5rem;
        height: 1.5rem;
        color: #9ca3af;
    }
`

export const ImageActions = styled.div`
    display: flex;
    gap: 0.5rem;
`

export const ImageActionButton = styled.button<{ $danger?: boolean }>`
    flex: 1;
    padding: 0.5rem 0.75rem;
    border-radius: 8px;
    font-size: 0.8125rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid ${({ $danger }) => ($danger ? '#fca5a5' : '#d1d5db')};
    background: white;
    color: ${({ $danger }) => ($danger ? '#dc2626' : '#374151')};

    &:hover {
        border-color: ${({ $danger }) => ($danger ? '#dc2626' : orange)};
        background: ${({ $danger }) => ($danger ? '#fef2f2' : '#fef3e2')};
        color: ${({ $danger }) => ($danger ? '#dc2626' : orange)};
    }
`

export const ImageOverlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    cursor: pointer;

    img {
        max-width: 90vw;
        max-height: 90vh;
        object-fit: contain;
        border-radius: 0.5rem;
    }
`

export const ProfileAvatar = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: ${orange};
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    font-weight: 600;
    flex-shrink: 0;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`
